import { SIGN_OUT } from '../auth/types';

import * as TYPES from './types';

export const initialState = {
  pending: false,
  notifications: {
    data: [],
    count: 0,
    pending: false,
  },
  notificationTokens: [],
  notificationFavoriteTokens: [],
  notificationTemplates: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.SET_NOTIFICATIONS_PENDING:
      return {
        ...state,
        notifications: {
          ...state.notifications,
          pending: action.payload,
        },
      };

    case TYPES.SET_NOTIFICATIONS_DATA:
      return {
        ...state,
        notifications: {
          ...state.notifications,
          data: action.payload.data,
          count: action.payload.count,
        },
      };

    case TYPES.SET_PENDING:
      return {
        ...state,
        pending: action.payload,
      };

    case TYPES.SET_NOTIFICATIONS_TOKENS:
      return {
        ...state,
        notificationTokens: action.payload,
      };

    case TYPES.SET_NOTIFICATIONS_FAVORITE_TOKENS:
      return {
        ...state,
        notificationFavoriteTokens: action.payload,
      };

    case TYPES.SET_NOTIFICATIONS_TEMPLATES:
      return {
        ...state,
        notificationTemplates: action.payload,
      };

    case SIGN_OUT:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
